import { defineMessages } from 'react-intl';

export default defineMessages({
    Actions: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Actions',
        defaultMessage: 'Actions'
    },
    ActionsMobile: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Actions Mobile',
        defaultMessage: 'Actions'
    },
    AddDriver: {
        id: 'quoteandbind.pa.directives.templates.pa-excluded-drivers.Add Excluded Driver',
        defaultMessage: 'Add Excluded Driver'
    },
    DateOfBirth: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    DateOfBirthMobile: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Date of Birth Mobile',
        defaultMessage: 'Date of Birth'
    },
    DriverHelpTitle: {
        id: 'common.directives.MLPUPWatercraftOperatorsTableDirectiveCtrl.DriverExclusionHelp.Title',
        defaultMessage: 'The driver must be either rated or excluded on this policy.'
    },
    DriverHelpText: {
        id: 'common.directives.MLPUPWatercraftOperatorsTableDirectiveCtrl.DriverExclusionHelp.Text',
        defaultMessage: 'The reason selected is not a valid reason to remove a driver. If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy.'
    },
    DriverAddedAlert: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.x has been excluded',
        defaultMessage: '{person} has been excluded and will not be covered.'
    },
    DriverAddedAlertNewProduct: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.x has been excluded',
        defaultMessage: '{person} has been excluded and will not be covered.'
    },
    EditDriverPopupTitle: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Edit an excluded driver',
        defaultMessage: 'Edit an excluded driver'
    },
    DriverHeader: {
        id: 'quoteandbind.pa.directives.templates.pa-excluded-drivers.Excluded Drivers',
        defaultMessage: 'Excluded Drivers'
    },
    DriverParagraph: {
        id: 'quoteandbind.pa.directives.templates.pa-excluded-drivers.Below are the members of the household which are excluded',
        defaultMessage: 'Below are the members of the household which are excluded'
    },
    DriverRemoved: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.x has been removed',
        defaultMessage: '{person} has been removed. <a>Undo</a>'
    },
    DriverPopupTitle: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Add an excluded driver',
        defaultMessage: 'Add an excluded driver'
    },
    Gender: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Gender',
        defaultMessage: 'Gender'
    },
    GenderMobile: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Gender Mobile',
        defaultMessage: 'Gender'
    },
    MaritalStatus: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Marital Status',
        defaultMessage: 'Marital Status'
    },
    MaritalStatusMobile: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Marital Status Mobile',
        defaultMessage: 'Marital Status'
    },
    Name: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Name',
        defaultMessage: 'Name'
    },
    NameMobile: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Name Mobile',
        defaultMessage: 'Name'
    },
    ReasonNotListed: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Reason not Listed',
        defaultMessage: 'Reason not Listed'
    },
    ReasonNotListedMobile: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Reason not Listed Mobile',
        defaultMessage: 'Reason not Listed'
    },
    RelationshipToInsured: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Relationship to Insured',
        defaultMessage: 'Relationship to Insured'
    },
    RelationshipToInsuredMobile: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Relationship to Insured Mobile',
        defaultMessage: 'Relationship to Insured'
    },
    SecondaryNamedInsuredExclusion: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.Secondary Named Insured Exclusion Error',
        defaultMessage: 'The reason selected is not a valid reason to exclude the secondary named insured. We require this person to be listed.'
    },
    SelectDriver: {
        id: 'quoteandbind.pa.views.pa-excluded-driver.SelectDriver',
        defaultMessage: 'Please enter the missing information. This is a required field.'
    }
});
